export const VIEWS = Object.freeze({
  HOME_PROMO: 'home_promo',
  HOME_TEAM: 'home_team',
  CREATE_JOIN_PROMO: 'create_join_promo',
  POTENTIAL_TEAMS: 'potential_teams',
  STEP_NAME: 'step_name',
  CREATE_TEAM: 'create_team',
  STEP_DOMAIN: 'step_domain',
  STEP_INVITE: 'step_invite',
  MANAGE_MEMBERS: 'manage_members',
  MEMBERS: 'members',
  CONFIRM_REMOVE: 'confirm_remove',
  MANAGE_ACCOUNT: 'manage_account',
  INVITE_BY_LINK: 'invite_by_link',
  INVITE_BY_EMAIL: 'invite_by_email',
  MANAGE_TEAM_INFO: 'manage_team_info',
  MANAGE_PAYMENT: 'manage_payment',
  MANAGE_SETTINGS: 'manage_settings',
  ACCEPT_DECLINE_INVITE: 'accept_decline_invite',
  PANEL_TEAMS: 'panel_teams',
  CONFIRM_LEAVE: 'confirm_leave',
  STEP_GIFT_DETAILS: 'step_gift_details',
  STEP_GIFT_RECIPIENTS: 'step_gift_recipients',
  STEP_GIFT_ADD_PAYMENT: 'step_gift_add_payment',
  STEP_GIFT_CHECKOUT: 'step_gift_checkout',
  CLOSE_GIFT_DIALOG: 'close_gift_dialog',
})

export const VIEW_TYPES = Object.freeze({
  PAGE: 'page',
  COMPONENT: 'component',
  DIALOG: 'dialog',
  TABLE: 'table',
  LIST: 'list',
})

export const ACTION_TYPES = Object.freeze({
  VIEWED: 'viewed',
  CLICKED: 'clicked',
  CHANGED: 'changed',
})

export const ACTION_TARGETS = Object.freeze({
  JOIN_OR_CREATE: 'join_or_create',
  INVITE_MEMBERS: 'invite_members',
  CREATE_TEAM: 'create_team',
  TEAM_NAME: 'team_name',
  NEXT: 'next',
  CLOSE: 'close',
  CANCEL: 'cancel',
  EMAIL_DOMAIN: 'email_domain',
  JOINABILITY_SETTING: 'joinability_setting',
  ADD_ANOTHER: 'add_another',
  EMAIL_ADDRESS: 'email_address',
  FINISH_SETUP: 'finish_setup',
  SEARCH_MEMBERS: 'search_members',
  SORT_MEMBERS: 'sort_members',
  REMOVE_MEMBER: 'remove_member',
  CONFIRM_REMOVE: 'confirm_remove',
  COPY_INVITE_LINK: 'copy_invite_link',
  INVITE_EMAIL_ADDRESSES: 'invite_email_addresses',
  SEND_INVITES: 'send_invites',
  EDIT: 'edit',
  SUBMIT: 'submit',
  CONFIRM_PAYMENT: 'confirm_payment',
  CONTACT_SALES: 'contact_sales',
  ACCEPT_INVITE: 'accept_invite',
  DECLINE_INVITE: 'decline_invite',
  MANAGE_TEAM: 'manage_team',
  LEAVE: 'leave',
  CONFIRM_LEAVE: 'confirm_leave',
  BACK: 'back',
  PURCHASE: 'purchase',
  CONFIRM: 'confirm',
  EXCLUDE: 'exclude',
  SEND_GIFTS: 'send_gifts',
  CHECK_MEMBER: 'check_member',
  CHECK_PAGE_MEMBERS: 'check_page_members',
  CHECK_ALL_MEMBERS: 'check_all_members',
  GIFT_REASON: 'gift_reason',
  GIFT_AMOUNT: 'gift_amount',
  GIFT_MESSAGE: 'gift_message',
})

export const ACTION_TARGET_TYPES = Object.freeze({
  BUTTON: 'button',
  INPUT: 'input',
  CHECKBOX: 'checkbox',
  RADIO: 'radio',
})
